import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    handleBarProfitInputComponentMount,
    handleGateFormFieldValueChange,
    handleGateFormSubmitClick,
    handleFieldSliderInputChange,
    handleFieldTextInputChange,
    handleFieldTextInputBlur,
    handleBreakDownIndicatorClick,
    handleBarProfitToolDataFormSubmitClick
} from './actions/actions'

import {
    formatBarProfitInputSetInputValue
} from '../utils'

import DataSetSection from './components/DataSetSection'
import GateForm from './components/GateForm'

export class BarProfitInput extends Component {

    componentDidMount() {
        this.props.dispatch(handleBarProfitInputComponentMount());
    }

    render() {
        const { state, dispatch } = this.props;

        const breakdownsBySetName = state.barProfitInput.breakdownsBySetName;

        const getDataSetSection = function(setName, index) {
            const setData = breakdownsBySetName[setName];

            const breakdownIndicatorClickHandlerGenerator = function (breakdown) {
                return function () {
                    dispatch(handleBreakDownIndicatorClick(setName, breakdown));
                }
            };
            const textInputChangeHandlerGenerator = function (activeBreakdown, field) {
                return function (event) {
                    dispatch(handleFieldTextInputChange(setName, activeBreakdown, field, event.target.value));
                }
            };
            const textInputBlurHandlerGenerator = function (activeBreakdown, field) {
                return function (event) {
                    dispatch(handleFieldTextInputBlur(setName, activeBreakdown, field, event.target.value));
                }
            };
            const sliderInputChangeHandlerGenerator = function (activeBreakdown, field) {
                return function (value) {
                    dispatch(handleFieldSliderInputChange(setName, activeBreakdown, field, value));
                }
            };

            const formattingFunction = function (value) {
                return formatBarProfitInputSetInputValue(setName, value);
            };

            return (
                <DataSetSection
                    key={ setName }
                    index={ index }
                    setName={ setName }
                    setData={ setData }
                    breakdownIndicatorClickHandlerGenerator={ breakdownIndicatorClickHandlerGenerator }
                    textInputChangeHandlerGenerator={ textInputChangeHandlerGenerator }
                    textInputBlurHandlerGenerator={ textInputBlurHandlerGenerator }
                    sliderInputChangeHandlerGenerator={ sliderInputChangeHandlerGenerator }
                    formattingFunction={ formattingFunction }
                    showSumRadialGraphic={ setName !== "pourCostPercent" }
                />
            );
        };

        return (
            <div>
                <div className="bar-profit-landing section">
                    <div className="bar-profit-landing-wrapper">
                        <div className="bar-profit-title-logo">
                            <div className="logo-wrapper">
                                <a className="brand-logo transition" href="https://www.bevspot.com">
                                    <span className="bevicon bevico-bevspot-logo transition"></span>
                                    <span className="bevicon bevico-logo-text transition"></span>
                                </a>
                                <h1 className="bar-profit-logo">
                                    <div className="top-rule"></div>
                                    <div className="top-rule second-top-rule"></div>
                                    Bar Profit Analysis
                                </h1>
                            </div>
                        </div>

                        <div className="opening-image">
                            <img style={ { width: '100%' } } src="/static/img/barprofit/SliderCircle.gif"/>
                        </div>
                        <div className="bar-profit-description bar-profit-title">
                            <h2> How does <em>your</em> bar stack up to the competition? </h2>
                            <p><strong>Now you can find out</strong> where your beverage program ranks nation-wide.</p>
                            <p><strong>Just answer three simple questions</strong> to receive your customized score with curated resources that have been proven to help our customers improve their bottom line.
                            </p>
                        </div>
                    </div>
                </div>

                <div id={"get-started"} className="section" style={{ position: "relative"}}>
                    {(state.gate.shown) ? (
                        <div className="bar-profit-gate-wrapper">
                            <div className="gate-top-button text-center">
                                <a className="bar-profit-button" href={ "#get-started" }>
                                    See&nbsp;How&nbsp;You&nbsp;Score&nbsp;<span className="bevicon bevico-keyboard-arrow-down"/>
                                </a>
                            </div>
                            <div>
                                <GateForm
                                    formData={ state.gate.formData }
                                    errorMessage={ state.gate.errorMessage }
                                    handleFormFieldValueChange={ function(field, value) {
                                        dispatch(handleGateFormFieldValueChange(field, value));
                                    }}
                                    submitButton={
                                        <button
                                            className="bar-profit-button spc-tp-sm"
                                            onClick={ function (event) {
                                                dispatch(handleGateFormSubmitClick())
                                            }}
                                        >
                                            Get Started
                                        </button>
                                    }
                                />
                            </div>
                        </div>
                    ) : (

                            <div id={"lets-go"} className="bar-profit-gate-wrapper">
                                <div className="gate-top-button text-center">
                                </div>
                                <div>
                                    <div className="container gate-form-container">
                                        <div className="row">
                                            <div className="col-xs-12 col-md-10 col-md-offset-1 pad-bt-md">
                                                <h2>Let’s Go!</h2>
                                                <p className="intro">Submit your sitting inventory, sales and pour cost numbers below to see how you score.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                    )}

                    <div id={"report-input-data"}>
                        { getDataSetSection("averageSittingInventory", 1) }

                        { getDataSetSection("annualSales", 2) }

                        { getDataSetSection("pourCostPercent", 3) }
                    </div>

                    <div className="bar-profit-submit-wrapper">
                        <button
                            className="bar-profit-button"
                            onClick={ function () {
                                dispatch(handleBarProfitToolDataFormSubmitClick());
                            }}
                        >
                            See Your Score
                        </button>
                    </div>
                    <div className="bar-profit-footer">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 bar-profit-landing-logo">
                                <div className="logo-wrapper">
                                    <a className="brand-logo transition" href="https://www.bevspot.com">
                                        <span className="bevicon bevico-bevspot-logo transition"></span>
                                        <span className="bevicon bevico-logo-text transition"></span>
                                    </a>
                                </div>
                            </div>
                            <div className="bar-profit-footer-content col-xs-12 col-sm-6 dark">
                                <h1>
                                    What is BevSpot?
                                </h1>
                                <p>
                                    BevSpot is a bar management software platform for inventory, ordering, invoicing and unlocking your bar’s sales data. So you can grow your business faster—from anywhere.
                                </p>
                                <a href="https://www.bevspot.com/product-tour/" target="_blank" className="bar-profit-button btn">
                                    Take the Tour
                                </a>
                            </div>
                            <div className="bar-profit-footer-content col-xs-12 col-sm-6 dark">
                                <h1>
                                    Need help finding your numbers?
                                </h1>
                                <p>
                                    Our hospitality consultants are here to walk you through generating a report and make sense of it all, plus provide feedback about any questions you might have.
                                </p>
                                <a href="https://www.bevspot.com/bar-profit-analysis-consultation/" target="_blank" className="bar-profit-button btn">
                                    Get Started
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BarProfitInput.propTypes = {
};

function mapStateToProps(state) {
    return {
        state: state
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BarProfitInput);
